import React from "react";
import "./footer.css";
import guestzaLogoImg from "../../images/logo_footer_updated.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="test">
      <footer className="footer">
        <div className="footer-container">
          {/* Logo and Contact Info */}


          {/* Menu + Redes Sociais */}
          <div className="footer-section-container">

            <div className="footer-section">
              <div className="footer-top">
                <div className="footer-logo-section">
                  <div className="footer-logo-wrapper">
                    <img
                      src={guestzaLogoImg}
                      className="footer-logo-icon"
                      alt="Logo"
                    />
                  </div>
                  <div className="footer-description">
                    <p className="footer-contact">+351 912 364 783</p>
                    <p className="footer-contact">hello@guestza.com</p>
                    <p className="footer-contact">
                      Rua Nova, 8100-060 Boliqueime, Portugal
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="footer-section" style={{width:'10%'}}>
              <h4 className="footer-heading">MENU</h4>
              <ul className="footer-list">
                {[
                  { label: "Home", href: "#home" },
                  { label: "Sobre nós", href: "#about" },
                  { label: "Serviços", href: "#services" },
                  { label: "Planos", href: "#plans" },
                  { label: "Contacte-nos", href: "#contacts" },
                ].map((item, index) => (
                  <li key={index}>
                    <a href={item.href} className="footer-link">
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Redes Sociais Section */}
            <div className="footer-section" style={{width:'15%'}}>
              <h4 className="footer-heading">REDES SOCIAIS</h4>
              <ul className="footer-list">
                {[
                  // { label: "Facebook", href: "#" },
                  { label: "LinkedIn", href: "https://www.linkedin.com/company/guestza/posts/?feedView=all" },
                  // { label: "Instagram", href: "#" },
                  { label: "Whatsapp", href: "#" },
                ].map((item, index) => (
                  <li key={index}>
                    <a href={item.href} className="footer-link">
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-section-cp">
              <p>© {currentYear}. Todos os direitos reservados.</p>
            </div>
          </div>


        </div>

      </footer>
    </div>
  );
};

export default Footer;